var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_221_1770)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4298 28.0393C43.1555 27.23 43.1555 24.7736 41.4287 23.9653L20.3354 14.0768C18.6033 13.2654 16.7143 14.8468 17.2064 16.6945L19.2885 24.502L28.1196 24.502C28.5128 24.5089 28.8877 24.6699 29.1633 24.9504C29.439 25.2309 29.5935 25.6085 29.5935 26.0018C29.5935 26.3951 29.439 26.7727 29.1633 27.0532C28.8877 27.3337 28.5128 27.4947 28.1196 27.5016L19.2885 27.5016L17.2075 35.3102C16.7143 37.1568 18.6044 38.7371 20.3354 37.9268L41.4298 28.0393Z",
    fill: "#009DFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_221_1770"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25.998,
    y: 0.545898,
    width: 36,
    height: 36,
    rx: 18,
    transform: "rotate(45 25.998 0.545898)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendicon);
export default __webpack_public_path__ + "static/media/sendicon.92e1bde49eeb25e01e4fae820f2972cd.svg";
export { ForwardRef as ReactComponent };